
<div class="app">
  <mobile />
  <Modal v-if="modal.show || loading" class="fadeIn animated">
    <Rule v-if="modal.type === 'rule'"></Rule>
    <Bind v-if="modal.type === 'bind'"></Bind>
    <noChance v-if="modal.type === 'noChance'"></noChance>
    <Share v-if="modal.type === 'share'"></Share>
    <DescModal v-if="modal.type === 'desc'"></DescModal>
    <WxModal v-if="modal.type === 'wx'"></WxModal>
    <Copy v-if="modal.type === 'copy'" :copy="modal.copy"></Copy>
    <Open v-if="modal.type === 'open'"></Open>
    <Win v-if="modal.type === 'win'" :win="modal.win"></Win>
    <Times v-if="modal.type === 'times'"></Times>
    <Prize v-if="modal.type === 'prize'" :prize="modal.prize"></Prize>
    <Loading v-if="loading" />
  </Modal>
  <Modal v-if="modal2.show" class="fadeIn animated">
    <Material v-if="modal2.type === 'material'" :material="modal2.material"></Material>
    <Address v-if="modal2.type === 'address'" :address="modal2.address"></Address>
  </Modal>
  <Orientation v-if="isMobile" />
</div>
